import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, watch } from 'vue';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  useSelectColumn,
  BaseButton,
  useCreateModal,
  BaseDialog,
  BaseTextContent
} from 'xrk-components';
import { formatter } from '@/utils';
import { DITHDRAWAL_STATUS } from '@/common/constants/bank';
import { RECEIVE_STATUS } from '@/common/constants/order';
import {
  querySupplierWithdrawList,
  getSupplierWithdrawAmount
} from '../data-source/apis';
import AccountMainWithdrawalDialog from './account-main-withdrawal-dialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'account-main-withdrawal-orders-dialog',
  props: {
    remove: {}
  },
  emits: ['success'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props;

const xrkTableRef = ref(null);
const withdrawAmount = ref(0);

const selections = computed(() => {
  return xrkTableRef.value?.getSelectionRows?.() || [];
});
const idList = computed(() => {
  return selections.value.map(item => item.id);
});

watch(
  () => selections.value,
  async v => {
    if (v.length) {
      const { data } = await getSupplierWithdrawAmount({
        idList: idList.value
      });
      withdrawAmount.value = data.withdrawAmount;
    } else {
      withdrawAmount.value = 0;
    }
  }
);

const getListAjax = async params => {
  return querySupplierWithdrawList(params);
};

const onCancel = () => {
  props.remove();
};
const onConfirm = () => {
  useCreateModal(AccountMainWithdrawalDialog, {
    amount: withdrawAmount.value,
    idList: idList.value,
    functionCode: 3,
    onSuccess() {
      emits('success');
      props.remove();
    }
  });
};

const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: false,
    text: '重置'
  },
  searchColumns: [
    useSelectColumn({
      prop: 'status',
      label: '提现状态',
      config: {
        placeholder: '请选择',
        options: DITHDRAWAL_STATUS
      }
    })
  ]
});

const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: '_selection',
      prop: 'id',
      align: 'center',
      fixed: 'left',
      width: 110,
      selectionDisabled: row => {
        const {
          price,
          isServicePriceWithdraw,
          serviceWithdrawStatus,
          payStatus
        } = row;
        if (!price || !isServicePriceWithdraw) return true;
        if (payStatus != 2) return true; // 订单未支付完成的不可提现
        if (![0, 3].includes(serviceWithdrawStatus)) return true; // 服务费未处于未提现和失败的不可提现
        return false;
      }
    }),
    useTableColumn({
      type: 'index',
      label: '序号',
      width: '80px'
    }),
    useTableColumn({
      label: '订单编号',
      prop: 'orderNo',
      width: '180px'
    }),
    useTableColumn({
      label: '终端支付状态',
      prop: 'payStatus',
      width: '180px',
      formatter: ({ cellValue }) =>
        formatter.defaultFormat(
          cellValue,
          () => RECEIVE_STATUS[cellValue].label
        )
    }),
    useTableColumn({
      label: '终端结算金额',
      prop: 'projectPayPrice',
      width: '180px',
      formatter: ({ cellValue }) => formatter.fen2yuan(cellValue)
    }),
    useTableColumn({
      label: '可提现服务费',
      prop: 'price',
      width: '180px',
      formatter: ({ cellValue }) => formatter.fen2yuan(cellValue)
    }),
    useTableColumn({
      label: '提现状态',
      prop: 'serviceWithdrawStatus',
      formatter: ({ cellValue }) =>
        formatter.defaultFormat(
          cellValue,
          () => DITHDRAWAL_STATUS[cellValue].label
        )
    }),

    useTableColumn({
      label: '到账时间',
      prop: 'finishPayAt',
      width: '180px',
      formatter: ({ cellValue }) => formatter.date(cellValue)
    })
  ]
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    title: "项目订单提现",
    width: "900px",
    "model-value": true,
    "show-close": true,
    "close-on-press-escape": false,
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode("关闭")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), {
        type: "primary",
        disabled: !withdrawAmount.value,
        onClick: onConfirm
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 下一步 ")
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(XrkTable), {
            ref_key: "xrkTableRef",
            ref: xrkTableRef,
            getListAjax: getListAjax,
            searchConfig: searchConfig.value,
            tableConfig: tableConfig.value
          }, {
            tableBefore: _withCtx(() => [
              _createTextVNode(" 提现金额 " + _toDisplayString(_unref(formatter).fen2yuan(withdrawAmount.value)) + "元 ", 1)
            ]),
            _: 1
          }, 8, ["searchConfig", "tableConfig"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})